import { DefaultOptionType } from 'rc-select/lib/Select';
import { createContext } from 'react';
import { AlgorithmSourceFormDataType } from '../../sources/schema/types';

interface AlgorithmJoinsWithMappingsGraphContextValue {
  algorithmSourcesById: Map<number, AlgorithmSourceFormDataType>;
  readOnly?: boolean;
  joinTypeOptions: DefaultOptionType[];
  mappingJoinTypeOptions: DefaultOptionType[];
  isDbSources: boolean;
}

export const AlgorithmJoinsWithMappingsGraphContext =
  createContext<AlgorithmJoinsWithMappingsGraphContextValue>(undefined!);
